<form [formGroup]="orderDetailsFormGroup">
  <div class="view-order-container">
    <glxy-alert
      *ngIf="shouldShowDetailsNeededBanner$ | async"
      type="warning"
      [showAction]="true"
      actionTitle="{{ 'COMMON.EDIT_ORDERS.SALES_ORDERS.VIEW_FORMS' | translate }}"
      [actionRouterLink]="'/sales-orders/' + order.businessId + '/work-order/' + order.orderId"
      data-action="view-forms"
    >
      <strong>
        {{ 'COMMON.EDIT_ORDERS.SALES_ORDERS.DETAILS_NEEDED_BANNER' | translate }}
      </strong>
      <span>-</span>
      {{ 'COMMON.EDIT_ORDERS.SALES_ORDERS.DETAILS_NEEDED_BANNER_DESCRIPTION' | translate }}
    </glxy-alert>
    <div class="main-column">
      <div>
        <orders-create-order-details
          [business]="business"
          [formGroup]="orderDetailsFormGroup"
          [orderId]="order.orderId"
          [contractStartDate]="order.requestedActivation"
          [contractDuration]="order.contractDuration"
          [editingDisabled]="!!order.leasedToAutomations"
        ></orders-create-order-details>
        <orders-history [order]="order"></orders-history>
        <sales-ui-sales-order-contents
          [compactView]="true"
          [partnerId]="business.externalIdentifiers.partnerId"
          [marketId]="business.externalIdentifiers.marketId"
          [businessId]="order.businessId"
          [orderId]="order.orderId"
        ></sales-ui-sales-order-contents>
      </div>

      <div *ngIf="showFulfillmentsCard$ | async">
        <work-order-sales-order-summary
          *ngIf="workOrderInfo$ | async as workOrderInfo"
          [workOrders]="workOrderInfo"
          [includeThermometer]="false"
          [persona]="workOrderPersona"
        ></work-order-sales-order-summary>
      </div>

      <ng-container *ngIf="showFulfillmentTrackers">
        <ng-container *ngIf="projectTrackerInfo$ | async as trackers">
          <ng-container *ngIf="trackers?.length > 0">
            <mat-card>
              <mat-card-header>
                <mat-card-title>
                  {{ 'FULFILLMENT.PROJECTS' | translate }}
                </mat-card-title>
              </mat-card-header>
              <project-tracker-simple
                *ngFor="let tracker of trackers"
                [projectTitle]="tracker.projectTitle"
                [projectIdentity]="tracker.projectIdentity"
                [subtasks]="tracker.subtasks"
                (askQuestionClicked)="handleAskQuestionClicked(tracker)"
              ></project-tracker-simple>
            </mat-card>
          </ng-container>
        </ng-container>
      </ng-container>

      <orders-attachments
        *ngIf="!hideAttachmentsSection"
        [ngClass]="{ 'non-printable': !order.attachments }"
        [files]="order.attachments"
        [orderId]="order.orderId"
        [businessId]="order.businessId"
        [uploadUrl]="attachmentsUploadUrl"
        [editingDisabled]="!!order.leasedToAutomations"
      ></orders-attachments>
      <ng-container class="print-page-break" *ngIf="productIds">
        <business-product-activation-prereq-form
          [businessId]="business.accountGroupId"
          [expanded]="false"
          [productIds]="productIds"
          [orderFormOptions]="orderFormOptions$ | async"
          [expanded]="expanded$ | async"
        ></business-product-activation-prereq-form>
      </ng-container>
      <ng-container class="print-page-break" *ngIf="orderConfig$ | async as orderConfig">
        <orders-form
          #orderForm
          [order]="order"
          [orderConfig]="orderConfig"
          [userOptions]="users"
          [orderFormOptions]="orderFormOptions$ | async"
          [fileUploadUrl]="fileUploadUrl"
          [showSelfSaveButton]="false"
          [parentForm]="orderFormGroup"
          [partnerId]="order.partnerId"
          [businessId]="order.businessId"
        ></orders-form>
      </ng-container>
    </div>
    <div class="right-column print-page-break">
      <sales-ui-sales-order-confirmation
        title="{{ 'COMMON.SUMMARY.TITLE' | translate }}"
        [partnerId]="order.partnerId"
        [marketId]="order.marketId"
        [editable]="false"
        [businessId]="order.businessId"
        [orderId]="order.orderId"
      ></sales-ui-sales-order-confirmation>
      <orders-notes
        *ngIf="!hideNotesSections"
        [ngClass]="{ 'non-printable': !order.notes }"
        [existingNotes]="order.notes"
        [orderId]="order.orderId"
        [businessId]="order.businessId"
        [editingType]="!!order.leasedToAutomations ? 'disabled' : 'toggleable'"
        [noteType]="'administrator'"
      ></orders-notes>
      <orders-notes
        *ngIf="!hideNotesSections"
        [ngClass]="{ 'non-printable': !order.customerNotes }"
        [existingNotes]="order.customerNotes"
        [orderId]="order.orderId"
        [businessId]="order.businessId"
        [editingType]="!!order.leasedToAutomations ? 'disabled' : 'toggleable'"
        [noteType]="'customer'"
      ></orders-notes>
      <orders-tags
        *ngIf="!hideTagsSection"
        [ngClass]="{ 'non-printable': !order.tags }"
        [editingType]="!!order.leasedToAutomations ? 'disabled' : 'toggleable'"
        [existingOrder]="order"
      ></orders-tags>
    </div>
  </div>
</form>

<project-tracker-sidenav-container class="project-tracker-sidenav-container"></project-tracker-sidenav-container>
<ng-template #commentsContent>
  <project-tracker-comments [projectTrackerInfo]="selectedProjectTrackerInfo"></project-tracker-comments>
</ng-template>
